"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/require-default-props */
const react_1 = require("react");
const blueprint_1 = require("@groma-dev/blueprint");
const Menu_module_scss_1 = __importDefault(require("./Menu.module.scss"));
/**
 * The Menu component is a container which center aligns its children vertically and applies space between styling to take up 100% of its width
 *
 * The `<Menu />` is intended to be used within the `<Header />` component.
 * @param props
 * @constructor
 */
exports.Menu = (0, react_1.forwardRef)((props, ref) => {
    const { active, children, testId, className } = props, args = __rest(props, ["active", "children", "testId", "className"]);
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, args, { className: (0, blueprint_1.classNames)('Header-menu-local', className, Menu_module_scss_1.default.menu, active && `${Menu_module_scss_1.default.active} Header-menu-active`), ref: ref }, dti, { children: children })));
});
